import * as types from "./homeActionTypes";

const stateObject = {
  payload: {},
  isLoading: false,
  isSuccess: false,
  error: null,
  isError: false
};

const initialState = {
  metaData: { ...stateObject },
  sendMessageState: { ...stateObject }
};

export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_HOME_DATA_LOADING:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: true
        }
      };
    case types.GET_HOME_DATA_SUCCESS:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_HOME_DATA_FAILURE:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SEND_CONTACT_US_LOADING:
      return {
        ...state,
        sendMessageState: {
          ...state.sendMessageState,
          isLoading: true
        }
      };
    case types.SEND_CONTACT_US_SUCCESS:
      return {
        ...state,
        sendMessageState: {
          ...state.sendMessageState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.SEND_CONTACT_US_FAILURE:
      return {
        ...state,
        sendMessageState: {
          ...state.sendMessageState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };
    default:
      return state;
  }
}
